import React from "react";
import {
  Box,
  Center,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useGeoLocations } from "../../hooks/useGeoLocations";
import { GeoLocationCardView } from "../GeoLocationCardView/GeoLocationCardView";

interface GeoLocationsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  businessId: string;
  overrides: { [key: string]: string };
}

const formatOverriddenCount = (count: number) =>
  `${count} location ${count === 1 ? "message" : "messages"} overridden`;

export const GeoLocationsDrawer: React.FC<GeoLocationsDrawerProps> = ({
  isOpen,
  onClose,
  businessId,
  overrides,
}) => {
  const { locations, isLoading } = useGeoLocations(businessId);

  const overriddenLocations = locations.filter((l) => {
    const id = l.Meta?.Id;
    return !!id && !!overrides[id];
  });

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      placement="right"
      size="md"
      preserveScrollBarGap
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>GEO-LOCATIONS</DrawerHeader>
        <DrawerBody>
          <Text mb={4} color="gray.700">
            {formatOverriddenCount(overriddenLocations.length)}
          </Text>

          {isLoading && (
            <Center py={6}>
              <Spinner />
            </Center>
          )}

          {!isLoading && overriddenLocations.length === 0 && (
            <Box textAlign="center" py={4} color="gray.600">
              No location overrides found.
            </Box>
          )}

          <VStack spacing={3} align="stretch">
            {overriddenLocations.map((location) => (
              <GeoLocationCardView
                key={location.GeoLocationId}
                location={location}
                overrideMessage={overrides[location.Meta?.Id ?? ""]}
              />
            ))}
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
